<template>
  <div class="file-box">
    <el-input v-if="showInput" v-model="fileName" disabled></el-input>
    <el-upload
        ref="upload"
        v-loading.fullscreen.lock="loading"
        :show-file-list="false"
        class="upload-row"
        multiple
        action=""
        :auto-upload="false"
        :limit="1"
        :on-change="handleChange">
      <slot>
        <el-button size="small" type="primary">点击上传</el-button>
      </slot>
    </el-upload>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5';
export default {
  name: "UploadFile",
  model: {
    event: "input",
    prop: 'clear'
  },
  props: {
    category: {  // 业务分类
      type: String,
      default: "TEST"
    },
    clear: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: ''
    },
    showInput: {
      type: Boolean,
      default: true,
    },
    chunkSize: {
      type: Number,
      default: 1024 * 10000
    },
    type: {
      type: [String, Array],
      default: 'image',
    }
  },
  data() {
    return {
      // 文件列表
      fileList: [],
      fileChunk: { // 文件块参数
        fileName: '', // 文件名称
        category: '', // 业务分类
        fileSize: 0, // 文件总大小
        chunks: 0,  // 分块总数
        size: 0, // 分块大小
        idx: 0, // 当前分块索引
        md5: '', // 文件md5
        fileCode: '', // 文件标识
        fileType: '' // 文件类型
      },
      // chunkSize: 1024 * 100, // 分块大小
      // category: 'APK', // 业务分类
      fileName: '',
      fileSize: '',
      loading: false
    }
  },
  watch: {
    clear: {
      handler(val) {
        if(val) {
          this.fileName = "";
          for (const key in this.fileChunk) {
            this.fileChunk[key] = '';
          }
          this.$emit('input', false);
        }
      },
      immediate: true,
      deep: true,
    },
    name: {
      handler(val) {
        this.fileName = val;
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {

    handleCheckType(type) {
      let fileType = type.split('/');

      let make = false;

      if(typeof this.type == 'string') {
        let type = this.type.split('/');
        if (type.length > 1) {
          let domType = fileType[1].split('.');
          if (fileType[0] != type[0] || domType[domType.length - 1] != type[1]) make = true;
        } else {
          if(fileType[0] != this.type) make = true;
        }
      } else {
        if(!this.type.includes(fileType[0])) make = true;
      }

      if(make) {
        this.$message.error(this.$t('lang.上传文件格式错误'));
        this.loading = false;
        this.$refs.upload.clearFiles();
        return true;
      }
      return false;

    },

    handleChange(file, fileList) {
      this.fileList = fileList;
      this.fileName = file.name;
      let res = this.handleCheckType(file.raw.type);
      if(res) return;
      this.onUpload();
    },
    onUpload() {
      const vm = this;
      vm.loading = true;
      if (vm.fileList && vm.fileList.length > 0) {
        let file = vm.fileList[0]
        let chunks = Math.ceil(file.size / vm.chunkSize);
        // 获取文件信息
        let fileType = file.raw.type
        let fileSize = file.size
        let fileName = file.name

        // 生成文件标识
        let fileCode = vm.getUuid()

        let chunk = {
          fileName: fileName,
          category: vm.category,
          fileSize: fileSize,
          chunks: chunks,
          size: 0,
          idx: 0,
          md5: '',
          fileCode: fileCode,
          fileType: fileType
        }

        // 创建文件md5
        const sliceLength = 10;
        const chunkSize = Math.ceil(file.size / sliceLength);
        vm.getFileMd5(file.raw, function (md5Code) {
          chunk.md5 = md5Code + '';
          vm.uploadChunk(chunk, file.raw)
        })

      }
    },
    uploadChunk(baseChunk, file,) {
      const vm = this;
      // 拷贝块
      let start = 0;
      let end;
      let index = 0;
      let uploadRequest = [];
      while (start < file.size) {
        end = start + vm.chunkSize;
        if (end > file.size) {
          end = file.size;
        }

        let chunk = JSON.parse(JSON.stringify(baseChunk))
        // 切块
        chunk.size = end - start;
        chunk.idx = index

        // 切块上传
        let result =  vm.uploadChunkFile(chunk, file, start, end);
        uploadRequest.push(result);
        start = end;
        index++;
      }

      Promise.all(uploadRequest).then(res => {
        console.log("上传成功", res);
        vm.loading = false;
        this.$emit('upload', {file,data:res[0].data.data});
        vm.$refs.upload.clearFiles();
      }).catch(err => {
        vm.loading = false;
        vm.$message.error(this.$t('lang.上传文件失败'));
        console.log("上传失败", err);
      })

    },
    uploadChunkFile(chunk, file, start, end) {
      const vm = this;
      let formData = new FormData();
      formData.append('file', file.slice(start, end));
      formData.append('category', vm.category);
      formData.append('fileCode', chunk.fileCode);
      formData.append('fileType', chunk.fileType);
      formData.append('md5', chunk.md5);
      formData.append('idx', chunk.idx);
      formData.append('fileSize', chunk.fileSize);
      formData.append('chunks', chunk.chunks);
      formData.append('size', chunk.size);
      formData.append('fileName', chunk.fileName);



      let result = new Promise((resolve, reject) => {
        vm.$http.post(vm.$api.file.upload, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          if (res.data.status != 200){
            reject(res);
          }  else  {
            resolve(res);
          }
        }).catch(err => {
          reject(err);
          // console.log('err', err);
        });
      });
      return result;
    },
    getUuid() {
      function s4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      return (s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4());
    },
    getFileMd5(file, callback) {
      const vm = this;
      const fileReader = new FileReader();
      const md5 = new SparkMD5()
      let index = 0;
      const loadFile = () => {
        const slice = file.slice(index, index + vm.chunkSize)
        fileReader.readAsBinaryString(slice)
      }
      loadFile()
      fileReader.onload = e => {
        md5.appendBinary(e.target.result)
        if (index < file.size) {
          index += vm.chunkSize
          loadFile()
        } else {
          callback(md5.end())
        }
      }
    }

  }

}
</script>

<style scoped>

.upload-row {
  /*margin-left: 12px;*/
}

.file-box {
  display: flex;
}


</style>
